import {
	mergeStyleSets,
	Stack,
	StackItem,
	Text,
	TextField,
} from '@fluentui/react';
import { observer } from 'mobx-react';
import { useEffect, useRef } from 'react';
import { EntityTypeEditorState } from '../EntityTypeEditor';
import { InfoTooltipLabel } from '../../../controls/InfoTooltipLabel';
import FieldPicker from '../../../controls/FieldPicker';
import { FieldType } from '../../../../API';

const contentStyles = mergeStyleSets({
	section: {
		display: 'flex',
		flexDirection: 'column',
		gap: '5px',
	}
});

function EntityTypeSetUp({
	state
}: {
	state: EntityTypeEditorState;
}) {

	const timer = useRef<number>();

	useEffect(() => () => window.clearTimeout(timer.current), []);

	return (
		<section className={contentStyles.section}>
			
			<InfoTooltipLabel 
					label='Identifier'
					title={`Internal identifier for this entity type. Used in API requests.`}>
				<Stack horizontal>

					<Text>{state.Id}</Text>

				</Stack>
			</InfoTooltipLabel>

			<Stack horizontal>
				<StackItem grow>
					<InfoTooltipLabel
							label='Singular type name'
							title="Name of the type of data you're handling. For example: case, matter, project, etc.">

						<TextField
							defaultValue={state.SingularName}
							onChange={(e, val) => {state.setSingularName(val ?? '' ); }}
						/>
					</InfoTooltipLabel>
				</StackItem>
				<StackItem grow style={{ marginLeft: 10 }}>
					<InfoTooltipLabel 
							label='Plural type name'
							title="Name of the type of data you're handling. For example: cases, matters, projects, etc.">

						<TextField
							defaultValue={state.PluralName}
							onChange={(e, val) => {state.setPluralName(val ?? '' ); }}
						/>
					</InfoTooltipLabel>
				</StackItem>
			</Stack>

			<InfoTooltipLabel 
					label='URL field'
					title={`Select the field in your data storage list that will contain the workspace URL when it's provisioned.`}>
				<Stack horizontal>

					<FieldPicker
						config={state.userConfig}
						preloadedFields={state.listUrlColumns}
						listUrl={state.SharePointListUrl}
						selectedFieldInternalName={state.SharePointStorageUrlField}
						fieldType={FieldType.Text}
						onFieldPicked={(fieldInternalName) => {
							state.setStorageUrlField(fieldInternalName);
						}}
					/>

				</Stack>
			</InfoTooltipLabel>
			

			<InfoTooltipLabel
					label='Content provisioning indicator field'
					title='Select the yes/no field that indicates whether content is currently being provisioned for this entity.'>
				<Stack horizontal>

					<FieldPicker
						config={state.userConfig}
						preloadedFields={state.listUrlColumns}
						listUrl={state.SharePointListUrl}
						selectedFieldInternalName={state.ContentProvisioningIndicatorField}
						fieldType={FieldType.Boolean}
						onFieldPicked={(fieldInternalName) => {
							state.setContentProvisioningIndicatorField(fieldInternalName);
						}}
					/>

				</Stack>
			</InfoTooltipLabel>
		</section>
	);
}

export default observer(EntityTypeSetUp);
